export const PROMO_SOURCE = "reactivated_winback20"
export const PROMO_SOURCE_10 = "reactivated_winback10"
export const PROMO_SOURCE_15 = "reactivated_winback15"
export const PROMO_SOURCE_25 = "reactivated_winback25"
export const INFLUENCER_GROWTH_SOURCE = "influencer_monthly_gwp_lp"
